import type { Game } from 'shared/modelTypes/index';
import { Avatar } from './Avatar';

type GameListProps = {
	games: Game[];
};
export function GameList({ games }: GameListProps) {
	return (
		<div class="flex flex-col gap-3">
			<div class="flex gap-4">
				<h2 class="text-gray-700 dark:text-gray-300">Games</h2>
			</div>
			<div class="max-w-[400px]">
				{!games.length && <small>No Games.</small>}
				{!!games.length && (
					<table class="min-w-full border-collapse overflow-hidden rounded-md bg-white text-sm shadow-md dark:bg-gray-800">
						<thead>
							<tr class="border-b border-gray-200 text-gray-800 dark:border-gray-700 dark:text-gray-100">
								<th class="p-3 text-left"></th>
								<th class="p-3 text-left">Name</th>
							</tr>
						</thead>
						<tbody>
							{games.map((game) => {
								return (
									<tr
										data-href={'/dashboard/games/' + game.kind}
										tabindex="0"
										role="link"
										class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
									>
										<td class="border-gray-200 p-3">
											<Avatar src={`/images/${game.kind}.jpg`} alt="game icon" />
										</td>
										<td class="border-gray-200 p-3">{game.name}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				)}
			</div>
		</div>
	);
}
